<app-modal (dismissed)="onCancelClick()" width="min(460px, calc(100vw - 24px))">
    <div class="general-dialog">
        <header class="dialog-header">
            <span class="eyebrow">{{ headerText | translate }}</span>
            <div class="dialog-title">{{ bodyText | translate }}</div>
        </header>

        <div class="dialog-body">
            @if (showReason) {
                <div class="dialog-field">
                    <label for="suspendReason">{{ 'Reason' | translate }}</label>
                    <input (ngModelChange)="setReason($event)" [(ngModel)]="suspendReason"
                           [placeholder]="'Reason' | translate"
                           class="form-control"
                           id="suspendReason" maxlength="30" name="suspendReason"
                           type="text"/>
                    <div class="radio-wrapper">
                        <label class="radio-option">
                            <input (change)="radioValueSuspensionHours(2)" class="radio-input" name="inlineRadioOptions"
                                   type="radio" value="2"/>
                            <span>2h</span>
                        </label>
                        <label class="radio-option">
                            <input (change)="radioValueSuspensionHours(4)" class="radio-input" name="inlineRadioOptions"
                                   type="radio" value="4"/>
                            <span>4h</span>
                        </label>
                        <label class="radio-option">
                            <input (change)="radioValueSuspensionHours(999999)" class="radio-input"
                                   name="inlineRadioOptions"
                                   type="radio" value="9999999"/>
                            <span>{{ 'Permanent' | translate }}</span>
                        </label>
                    </div>
                </div>
            }

            @if (showPriceInput) {
                <div class="dialog-field">
                    <label for="priceInput">{{ 'Price per km' | translate }}</label>
                    <input (ngModelChange)="setPrice($event)" [(ngModel)]="priceInput" class="form-control"
                           id="priceInput"
                           maxlength="30" name="priceInput" placeholder="Ex: 2.59"
                           type="number"/>
                    <div class="radio-wrapper">
                        <label class="radio-option">
                            <input (change)='radioPackageType("standard")' class="radio-input" name="inlineRadioOptions"
                                   type="radio" value="standard"/>
                            <span>{{ 'Standard' | translate }}</span>
                        </label>
                        <label class="radio-option">
                            <input (change)='radioPackageType("premium")' class="radio-input" name="inlineRadioOptions"
                                   type="radio" value="premium"/>
                            <span>{{ 'Premium' | translate }}</span>
                        </label>
                    </div>
                </div>
            }

            <div class="dialog-actions">
                @if (showCancelButton) {
                    <button (click)="onCancelClick()" class="btn btn-success" type="button">
                        {{ cancelButtonText | translate }}
                    </button>
                }
                <button (click)="onConfirmClick()" [class.btn-danger]="danger"
                        [class.btn-primary-action]="!danger" class="btn" type="button">
                    {{ confirmButtonText | translate }}
                </button>
            </div>
        </div>
    </div>
</app-modal>
